export const searchData = (e, projects, setResult) => {
    setResult(
        projects?.filter(dataContainsTerm(e))
    );
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.Title?.toString().toLowerCase().includes(word) &&
            startsWith(data.Title?.toString().toLowerCase(), word)) {
                return true;
        } else if (data.Pain?.toString().toLowerCase().includes(word) || 
            startsWith(data.Pain?.toString().toLowerCase(), word)) {
                return true;
        } else if (data.ValueProp?.toString().toLowerCase().includes(word) || 
            startsWith(data.ValueProp?.toString().toLowerCase(), word)) {
                return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}